import type { PropsWithChildren } from "react";
import { useTranslation } from "react-i18next";
import { PublicFooter } from "@/components/marketing/PublicFooter";
import { PublicHeader } from "@/components/marketing/PublicHeader";

export function PublicShell({ children }: PropsWithChildren) {
  const { t } = useTranslation();

  return (
    <div className="flex min-h-screen flex-col bg-bg text-text">
      <a
        href="#main-content"
        className="fixed left-4 top-4 z-[70] -translate-y-24 border border-white bg-[#101211] px-4 py-3 text-sm font-semibold text-white focus:translate-y-0 focus:outline-none focus:ring-2 focus:ring-white focus:ring-offset-2 focus:ring-offset-[#101211]"
      >
        {t("common.skip_to_content")}
      </a>
      <PublicHeader />
      <main id="main-content" tabIndex={-1} className="min-w-0 flex-1">
        {children}
      </main>
      <PublicFooter />
    </div>
  );
}
